<template>
  <div class="forditas-wrapper" >
    <div class="row" v-if="!checkDataIsEmpty">
      <div class="col-lg-8">
        <form class="" enctype='multipart/form-data' action="#" method="post" onsubmit="sendForditasUrlap(event)">
          <div id="forditas-rendeles-urlap" >

              <ServiceTypeField
                :fieldData="formDatas['service_type']"
                :serviceType.sync="serviceType"
              />

              <LanguageSelector
                :fieldData="formDatas['source_language']"
                :srcLanguage.sync="srcLanguage"
                :tgtLanguage.sync="tgtLanguage"
                :files="files"
              />

              <AdatokField
                :email.sync="email"
                :phone.sync="phone"
                :apiUrl="apiUrl"
                :megerosites.sync="megerosites"
              />

              <SpecializationField
                :specialization.sync="specialization"
                :documentType.sync="documentType"
                :fieldData="formDatas['specialization']"
                :files="files"
                :documentsSample="documentsSample"
                v-if="firstPartPassed"
              />

              <QuantityTypeField
                :fieldData="formDatas['quantity_type']"
                :quantity.sync="quantity"
                :quantityType.sync="qtyType"
                :specialization="specialization"
                :filesVal.sync="files"
                :apiUrl="apiUrl"
                :srcLanguage="srcLanguage"
                :fileProcessingState.sync="fileProcessingState"
                :charRepeats.sync="charRepeats"
                :fileScanningHasError.sync="fileScanningError"
                :chars.sync="chars"
                :documentInfo.sync="documentInfo"
                v-if="firstPartPassed"
              />

              <JavasoltHataridoField
                :hatarido="javasoltHatarido"
                v-if="firstPartPassed && secondPartPassed"
              />

              <HataridoModositasaField
                :hatarido.sync="hatarido"
                :kategoria="hataridoKategoria"
                v-if="firstPartPassed && secondPartPassed"
              />

              <ForditasTeljesitesenekModjaField
                :fieldData="formDatas['forditas_teljesitesenek_modja']"
                :forditasTeljesitesenekModja.sync="forditasTeljesitesenekModja"
                v-if="firstPartPassed && secondPartPassed"
                :specialization="specialization"
              />

              <ForditasDijaField
                :ar="formatPrice(normalAr)"
                :langPrices="langPrices"
                :qty="quantity"
                :quantityType="qtyType"
                :arNumber="arNumber"
                :kedvezmeny="(volumeDiscount+repeatDiscount)"
                :isLessThenMinAr="isLessThenMinAr"
                v-if="firstPartPassed && secondPartPassed"
                :serviceType="serviceType"
              />

          </div>
          <div
            id="forditas-rendeles-urlap-add-to-cart"
          >
            <span class="finish-circle" :class="{finished: validProductData }">
                <span class="glyphicon glyphicon-ok" aria-hidden="true"></span>
            </span>
            <div class="box container" v-if="firstPartPassed && secondPartPassed">
              <div class="row">
                <h2>Projekt indítása</h2>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <div class="ico">
                      <img src="/wp-content/themes/lebe-childtheme/assets/images/ico/kosar.png" alt="">
                  </div>
                  <div class="ico-left">
                    <h4 class="font-big">Ár</h4>
                    <div>
                      Alapdíj: {{ formatPrice(normalAr) }} + ÁFA
                    </div>
                    <div class="appeal">
                      <div class="color-secondary font-big" v-if="mennyisegiKedvezmeny > 0">
                        MENNYISÉGI KEDVEZMÉNY: {{ formatHuf(mennyisegiKedvezmeny) }}
                      </div>
                      <div class="color-secondary font-big" v-if="ismetlodesiKedvezmeny > 0">
                        ISMÉTLŐDÉSI KEDVEZMÉNY: {{ formatHuf(ismetlodesiKedvezmeny) }}
                      </div>
                      <div class="color-danger font-big" v-if="felar">
                        Sürgősségi felár: {{felar}} FT
                      </div>
                      <div class="color-primary big font-big">VÉGÖSSZEG: {{ar}} FT + ÁFA</div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <h4 class="font-big">További opciók</h4>
                  <div class="form-group">

                    <div class="radio" >
                      <input
                        id="change-normal-forditas"
                        type="radio"
                        v-model.number="tovabbiOpcio"
                        value="1"
                        name="tovabbi-opcio" :disabled="!priceReady"
                      >
                      <label for="change-normal-forditas">
                        Fordítás normál határidővel<br>
                        <span class="color-primary">
                          {{formatPrice(nyelviAr*(1-volumeDiscount-repeatDiscount))}} + ÁFA
                        </span>
                      </label>
                    </div>

                    <div class="radio" >
                      <input
                        type="radio"
                        id="change-normal-lektoralas-forditas"
                        v-model.number="tovabbiOpcio"
                        value="2"
                        name="tovabbi-opcio"
                        :disabled="!priceReady"
                      >
                      <label for="change-normal-lektoralas-forditas">
                        Fordítás + lektorálás normál határidővel<br>
                        <span class="color-primary">
                          {{formatPrice(nyelviAr*1.5*(1-volumeDiscount-repeatDiscount))}} + ÁFA
                        </span>
                      </label>
                    </div>

                    <div class="radio" v-if="normalCapacityDays > 2">
                      <input
                        type="radio"
                        id="change-surgos-forditas"
                        v-model.number="tovabbiOpcio"
                        value="3"
                        name="tovabbi-opcio"
                        :disabled="!priceReady"
                      >
                      <label for="change-surgos-forditas">
                        Fordítás sürgős határidővel<br>
                        <span class="color-primary">
                          {{formatPrice(surgosAr*(1-volumeDiscount-repeatDiscount))}} + ÁFA
                        </span>
                      </label>
                    </div>

                    <div class="radio" v-if="normalCapacityDays > 2">
                      <input
                        type="radio"
                        id="change-surgos-lektoralas-forditas"
                        v-model.number="tovabbiOpcio"
                        value="4"
                        name="tovabbi-opcio"
                        :disabled="!priceReady"
                      >
                      <label for="change-surgos-lektoralas-forditas">
                        Fordítás + lektorálás sürgős határidővel<br>
                        <span class="color-primary">
                          {{formatPrice(surgosAr*1.5*(1-volumeDiscount-repeatDiscount))}} + ÁFA
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-8 col-md-offset-2 font-weight-bold text-center">
                  <strong>Teljesítés határideje:</strong>
                  <div class="color-primary big font-big mb-1e">
                    {{hatarido?formatDeadline(hatarido):javasoltHatarido}}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label for="comment">Megjegyzés:</label>
                    <textarea class="form-control" v-model="note" rows="5" id="comment"></textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col" style="margin-bottom: 1.5em">
                  <div class="alert alert-warning" v-if="fileProcessingState">
                    A folytatáshoz várja meg a fájlok feldolgozását!
                  </div>
                  <div class="alert alert-warning" v-else-if="!validProductData">
                    A megrendelés leadásához kérjük töltse ki a pirossal jelölt szekciókat
                  </div>
                </div>
              </div>
              <div class="flex-row">
                <div class="flex-row-item">
                  <button
                    type="button"
                    class="btn-primary"
                    :disabled="!validProductData || waitResponse || fileScanningError || (this.hataridoKategoria === 'Kérem keressen fel!') "
                    @click="trackOrder();sendToWpCart()"
                  >
                    Megrendelés
                  </button>
                </div>
                <div class="flex-row-item mt-2">
                  <button
                    type="button"
                    class="btn-secondary"
                    @click="trackOffer();addToOffer()"
                    :disabled="!validProductData || waitResponse || (this.hataridoKategoria === 'Kérem keressen fel!') "
                  >
                    Árajánlat e-mailben
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="alert alert-info" style="margin-top: 1em" role="alert">Ha később szeretné megrendelni a fordítást, az ajánlatot elküldjük e-mail címére. <br> Később bármikor megrendelheti.</div>
              </div>
            </div>
            <div class="box container" v-else>
              <div class="row">
                <div class="alert alert-info mt-0" role="alert" v-if="firstPartPassed"> A folytatáshoz és az árak megtekintéséhez töltse fel a fordítandó fájlokat.</div>
                <div class="alert alert-info mt-0" role="button" v-else><span @click="triggerSendAdatok()">A folytatáshoz töltse ki a mezőket és erősítse meg adatait!</span></div>
              </div>
            </div>
          </div>
        </form>

      </div>
      <div class="col-lg-4 col-md-12">
        <ForditasSummary
          :ar="ar"
          :karakter="quantity"
          :quantityType="qtyType"
          :hatarido="hatarido"
          :javasoltHatarido="javasoltHatarido"
        />
      </div>
      <PopupMessage
        v-if="popupMessageShow"
        :response="wpApiResponse"
        :responseType="wpApiResponseType"
        :popupState.sync="popupMessageShow"
        :stateMessage="stateMessage"
        :checkoutPage="checkoutPageUrl"
      />
    </div>
    <div class="row" v-else>
      Betöltés
    </div>

  </div>
</template>

<script>
//fields
import ServiceTypeField from "./Field/ServiceType"
import LanguageSelector from "./Field/LanguageSelector"
import AdatokField from "./Field/Adatok"
import SpecializationField from "./Field/Specialization"
import QuantityTypeField from "./Field/QuantityType"
import JavasoltHataridoField from "./Field/JavasoltHatarido"
import HataridoModositasaField from "./Field/HataridoModositasa"
import ForditasDijaField from "./Field/ForditasDija"
import ForditasTeljesitesenekModjaField from "./Field/ForditasTeljesitesenekModja"
//popup
import PopupMessage from "./Popup/Message"

//summary
import ForditasSummary from "./ForditasSummary"
export default {
  name: 'ForditasForm',
  data: function(){
    return {
      count: 2,
      //form data (api által adott json tömb)
      formDatas: {},
      //api url
      apiUrl: '/wp-json/forditas_api/',
      //alapértelmezett nyelv kulcs
      defLangKey: 'magyar',
      minPrice: 9500,
      quantity: 1,
      quantityType: 'karakterszam',
      tgtLanguage: [],
      srcLanguage: '',
      specialization: '',
      hatarido: '',
      serviceType: 'translate',
      email: '',
      phone: '',
      forditasTeljesitesenekModja: 'elektronikus_formaban_zaradek_nelkul',
      files: [],
      note: '',
      //for popup
      popupMessageShow: false,
      wpApiResponse: [],
      wpApiResponseType: '',
      hasReponse: false,
      waitResponse: false,
      productId: 0,
      stateMessage: '',
      checkoutPageUrl: '',
      documentType: '',
      //file feldolgozás állapota (van-e feldolgozás)
      fileProcessingState: false,
      charRepeats: 0,
      fileScanningError: false,
      chars: [],
      //dokumentum minták a specializációkhoz
      documentsSample: {},
      //feltöltött dokumentum statisztikáit leíró kulcsok (documentId fileId)
      documentInfo: [],
      megerosites: false
    }
  },
  components: {
    ServiceTypeField,
    LanguageSelector,
    AdatokField,
    SpecializationField,
    QuantityTypeField,
    JavasoltHataridoField,
    HataridoModositasaField,
    ForditasTeljesitesenekModjaField,
    ForditasDijaField,
    ForditasSummary,
    PopupMessage
  },
  mounted() {
    //környezet ellenőrzése
    if(process.env.NODE_ENV == 'development') {
      //dev modehoz a local development url hozzáadása
      this.apiUrl = "http://nonstopforditas-frontend.127.0.0.1.nip.io" + this.apiUrl
    }
    //formhoz tartozó adatok lekérése
    this.getFormDatas()
    //get product data
    this.getProductData()

    console.log(this.$parent.$refs)
  },
  created() {
    //apply local storages data
    let storagedDataJson = localStorage.getItem("miniform-data")
    if(storagedDataJson != null) {
      let storagedData = JSON.parse(storagedDataJson)
      this.serviceType = storagedData['serviceType']
      this.srcLanguage = storagedData['srcLanguage']
      this.tgtLanguage = storagedData['tgtLanguage']
      this.email = storagedData['email']
      this.phone = storagedData['phone']
    }
    //remove local storage
    localStorage.removeItem("miniform-data")
  },
  computed: {
    qtyType() {
      if(this.documentType != '') {
        //search specialization
        let qtyType = this.getDocumentQtyType(this.documentType)
        if(qtyType) {
          return qtyType
        }
      }
      return this.quantityType
    },
    checkDataIsEmpty() {
      return Object.keys(this.formDatas).length === 0 && this.formDatas.constructor === Object
    },
    tovabbiOpcio: {
      get() {
        let opt = 0
        this.hataridoKategoria
        //#1
        if( this.hataridoKategoria == 'Normál' && this.serviceType == "translate" ) {
          opt = 1
        }
        //#2
        else if( this.hataridoKategoria == 'Normál' && this.serviceType == "translate_and_proofread" ) {
          opt = 2
        }
        //#3
        else if( this.hataridoKategoria == 'Sürgős' && this.serviceType == "translate"
        ) {
          opt = 3
        }
        //#4
        else if( this.hataridoKategoria == 'Sürgős' && this.serviceType == "translate_and_proofread"
        ) {
          opt = 4
        }
        return opt
      },
      set(val) {
        switch(val) {
          case 1:
            this.serviceType = "translate"
            //check hatid kat
            if(this.hataridoKategoria != 'Normál') {
              //set normal
              this.hatarido = ""
            }
            break;

          case 2:
            this.serviceType = "translate_and_proofread"
            if(this.hataridoKategoria != 'Normál') {
              //set normal
              this.hatarido = ""
            }
            break;

          case 3:
            this.serviceType = "translate"
            //set surgos
            this.hatarido = this.getStartCapacityDate('surgos')
            break;

          case 4:
            this.serviceType = "translate_and_proofread"
            //set surgos
            this.hatarido = this.getStartCapacityDate('surgos')
            break;
        }
      }
    },
    hataridoDate() {
      if(this.hatarido !="" || this.hatarido) {
        return new Date(this.hatarido)
      }
      return null
    },
    //idegenről idegenre nyelvi szorzó
    foreignToForeign() {
      return this.formDatas['global_prices']['foreign_lang_mult']['value']
    },
    //szolgáltatás típusától függő ár szorzó
    serviceTypeMult() {
      if(this.serviceType != '') {
        return this.formDatas['service_type']['datalist']['options'][this.serviceType]['mult']
      }
      return 1
    },
    //mennyiségi kedvezmény értéke (float)
    volumeDiscount() {
      let discount = 0
      if(
        this.quantity > 0 &&
        this.qtyType !=''
      ) {
        let
          rate = this.formDatas['quantity_type']['datalist']['options'][this.qtyType]['discount']['rate'],
          to = this.formDatas['quantity_type']['datalist']['options'][this.qtyType]['discount']['to'],
          qtyCounter = this.quantity*this.tgtLanguage.length,
          toCounter = 0

        while(qtyCounter > to && toCounter*rate < this.maxVolumeDiscount ) {
          qtyCounter -= to
          toCounter++
        }
        discount = toCounter*rate
      }
      return discount
    },
    hataridoKategoria(){
      if( (this.hatarido !="" && this.hatarido ) && this.javasoltHatarido != '-') {
        let
          normalDate = this.getNormalCapacityDate(),
          hatidDate = new Date(this.hatarido)
        //nem normál határidő
        if(this.getDayDiff(normalDate, hatidDate) > 0) {
          let
            extra_surgosDate = this.getStartCapacityDate('extra_surgos'),
            surgosDate = this.getStartCapacityDate('surgos')
          //sürgős (a határidő nagyobb vagy egyenlő)
          if(this.getDayDiff(surgosDate, hatidDate) <= 0) {
            return 'Sürgős'
          }
          //surgos alatt (extra sürgős)
          else if(
            this.getDayDiff(surgosDate, hatidDate) > 0
            && this.getDayDiff(extra_surgosDate, hatidDate) <= 0
          ) {
            return 'Extra sürgős'
          }
          //extra surgos alatt (telefonhívásos figyelmeztetés)
          else {
            //automatikusan „Keressen fel“ kategória bővítése
            if(this.minQuantityRule) {
              return 'Sürgős'
            }
            return 'Kérem keressen fel!'
          }
        }
      }
      return 'Normál'
    },
    /**
     * Felár mértéke ft-osított formában
     * @type string|null
     */
    felar() {
      if(this.felarSzorzo) {
        return this.formatNumber(Math.round(this.felarSzorzo * this.normalAr))
      }
      return null
    },
    /**
     * Felár szorzó mértéke
     * @return int
     */
    felarSzorzo() {
      if(this.hatarido !="" && this.javasoltHatarido != '-') {
        //sürgős
        if(this.hataridoKategoria == 'Sürgős') {
          return this.formDatas['global_prices']['surcharges']['values']['surgos']['value']
        }
        //extra surgos
        else if(this.hataridoKategoria == 'Extra sürgős') {
          return this.formDatas['global_prices']['surcharges']['values']['extra_surgos']['value']
        }
      }
      return 0
    },
    //mennyiségi kedvezmény maximuma (0-1 közt)
    maxVolumeDiscount() {
      return this.formDatas['global_prices']['max_volume_discount']['value']
    },
    //javasolt határidő a normál vállalási határidőhöz
    javasoltHatarido() {
      let hatid = '-'
      if(
        this.quantity > 0
        && typeof this.qtyType == 'string'
        && this.qtyType.length > 1
        && this.tgtLanguage.length > 0
      ) {
        hatid = this.formatDeadline(this.getNormalCapacityDate())
      }
      return hatid
    },

    javasoltHataridoDate() {
      let hatid = '-'
      if(
        this.quantity > 0
        && typeof this.qtyType == 'string'
        && this.qtyType.length > 1
        && this.tgtLanguage.length > 0
      ) {
        hatid = this.formatDate(this.getNormalCapacityDate())
      }
      return hatid
    },

    //normál kapacitáshoz tartozó elvégzéshez szükséges napok száma
    normalCapacityDays() {
      return Math.ceil(
        this.serviceTypeMult
        * (this.quantity/this.getCapacity('normal'))
        * this.targetLangDeadlineMultiplier
      ) + this.getDefaultDeadlineMultiplier()
    },
    repeatDiscount() {
      if(this.quantityType == 'karakterszam' && this.quantity > 0 && this.charRepeats.length > 0) {
        return this.charRepeats.reduce((a, b) => a + b) / this.quantity / 2
      } else {
        return 0
      }
    },
    langPrices() {
      let
        prices = [],
        srcPrices = null
      //alapértelmezett nyelvnek nincsenek árai (forrásnyelv ára)
      if(this.priceReady) {
        let unitPrice = 0
        if(this.srcLanguage != this.defLangKey) {
          srcPrices = this.getLanguagePrices(this.srcLanguage)
        }
        this.tgtLanguage.forEach((item)=>{
          //magyarról
          if(this.srcLanguage == this.defLangKey) {
            let itemPrices = this.getLanguagePrices(item.value)
            if(itemPrices == null) {
              return 'error';
            }
            unitPrice = itemPrices.fromDef;
          }
          //magyarra
          else if(item.value == this.defLangKey) {
            unitPrice = srcPrices.toDef
          }
          //idegenről idegenre
          else {
            let itemPrices = this.getLanguagePrices(item.value)
            if(itemPrices == null) {
              return 'error';
            }
            unitPrice = Math.max(
              itemPrices.fromDef,
              itemPrices.toDef,
              srcPrices.fromDef,
              srcPrices.toDef
            ) * this.foreignToForeign
          }
          if(unitPrice > 0) {
            // langSpecPrice, value, label, unitPrice
            prices.push(
              this.crateLangItemPrices(item.value, item.label, unitPrice* this.serviceTypeMult)
            )
          }
        })
      }
      return prices
    },
    //nyelvi ár mennyiség, mennyiségi típus, nyelvek száma, nyelvek áraitól függő árképzés
    nyelviAr() {
      let sum = 0

      if(this.priceReady) {
        let srcPrices = null
        //Nyelvi árak kiszámítása
        //alapértelmezett nyelvnek nincsenek árai (forrásnyelv ára)
        if(this.srcLanguage != this.defLangKey) {
          srcPrices = this.getLanguagePrices(this.srcLanguage)
        }

        this.tgtLanguage.forEach((item)=>{
          //magyarról
          if(this.srcLanguage == this.defLangKey) {
            let itemPrices = this.getLanguagePrices(item.value)
            if(itemPrices == null) {
              return 'error';
            }
            sum += itemPrices.fromDef * this.quantity
          }
          //magyarra
          else if(item.value == this.defLangKey) {
            sum += srcPrices.toDef * this.quantity
          }
          //idegenről idegenre
          else {
            let itemPrices = this.getLanguagePrices(item.value)
            if(itemPrices == null) {
              return 'error';
            }
            sum += Math.max(
              itemPrices.fromDef,
              itemPrices.toDef,
              srcPrices.fromDef,
              srcPrices.toDef
            ) * this.foreignToForeign * this.quantity
          }
        })
      }

      return sum
    },
    /**
     * automatikusan „surgos“ kategória
     * @return bool
     */
    minQuantityRule() {
      if(this.quantity && this.qtyType && this.hatarido) {
        let
          deadline = new Date(this.hatarido),
          tomorrow = new Date();
        //napok inkrementálás 1-gyel
        tomorrow.setDate(tomorrow.getDate() + 1)
        //órák nullázása
        tomorrow.setHours(0,0,0,0)
        //a határidő holnapi nap
        let  isTomorrow = tomorrow.getTime() == deadline.getTime()
        if(isTomorrow) {
          return (
            //karakterszám 5000 alatt
            this.qtyType == 'karakterszam' && this.quantity <= 5000 ||
            //darabszám 1 alatt
            this.qtyType == 'darabszam' && this.quantity <= 1 ||
            //oldalszám 2 alatt
            this.qtyType == 'oldalszam' && this.quantity <= 2
          )
        }
      }
      return false
    },
    priceReady() {
      let ready = false;

      ready =
        this.tgtLanguage.length > 0
        && this.srcLanguage.length > 0
        && this.quantity > 0
        && this.qtyType.length > 0
        && this.serviceType.length > 0
      return ready
    },
    //teljes nettó ár kiszámolása formázott
    ar() {
      let ar = this.arNumber
      return this.formatNumber(ar)
    },
    //teljes ár szám
    arNumber() {
      let ar = this.minPrice
      if(
        this.priceReady
      ) {
        let sum = 0

        sum += this.eredetiAr
        //menniységi kedvezmény alkalmazása
        sum -= sum*(this.volumeDiscount + this.repeatDiscount)
        sum = Math.round(sum)

        if(sum<this.minPrice) {
          sum = this.minPrice
        }
        return sum
      }
      return ar
    },
    isLessThenMinAr() {
      return this.minPrice >= this.arNumber
    },
    /**
     * Normál ár
     * @return int
     */
    normalAr() {
      let sum = 0
      if(this.priceReady) {
        //nyelvi ár hozzáadása
        sum += this.nyelviAr

        //szolgáltatás típusától függő árazás
        sum *= this.serviceTypeMult
      }
      return sum
    },
    //határidőhöz szükséges nyelvek száma szorzó
    targetLangDeadlineMultiplier() {
      if(this.srcLanguage == this.defLangKey) {
        return 1
      } else {
        return this.tgtLanguage.length
      }
    },
    surgosAr() {
      if(this.priceReady) {
        return this.nyelviAr * (1 + 1* this.getFelarSzorzo('surgos'))
      }
      return 0
    },
    // eredeti ár kiszámolása (ár kedvezmény nélkül)
    eredetiAr() {
      let sum = 0
      if(this.priceReady) {
        sum += this.normalAr
        //felár alkalmazása
        sum += this.felarSzorzo * sum
      }
      return sum
    },
    mennyisegiKedvezmeny() {
      if(this.priceReady) {
        return this.eredetiAr * this.volumeDiscount
      }
      return 0
    },
    ismetlodesiKedvezmeny() {
      if(this.priceReady) {
        return this.eredetiAr * this.repeatDiscount
      }
      return 0
    },
    // első 3 pont valid
    firstPartPassed() {
      return (
        // 1 blokk
        this.serviceType.length > 0
        // 2 blokk
        && this.srcLanguage.length > 0
        && this.tgtLanguage.length > 0
        //3 blokk
        && this.email.length > 0
        // a phone-ra vonatkozó validációt ki kellett kapcsolni, mert az ügyfél kérésére opcionálisan megadható mező lett
        //megerősítése gomb
        && this.megerosites
      )
    },
    // Karakter szám megnövekedett ez egy sikeres fájl felöltés után fog bekövetkezni
    secondPartPassed() {
      let quantity = (this.qtyType == 'karakterszam') ? this.quantity > 1 : true;
      return (
        quantity && this.files.length > 0
      )
    },
    // a termék attribútumai helyesen vannak kitöltve visszakerülnek az adatok
    // a phone-ra vonatkozó validációt ki kellett kapcsolni, mert az ügyfél kérésére opcionálisan megadható mező lett
    validProductData() {
      if(
        this.specialization.length > 0
        && this.quantity > 0
        && this.srcLanguage.length > 0
        && this.qtyType.length > 0
        && this.serviceType.length > 0
        && this.email.length > 0
        && this.tgtLanguage.length > 0
        && this.files.length > 0
        && this.forditasTeljesitesenekModja.length > 0
        && !this.fileProcessingState
      ) {
        let targetLangs = [];
        for(const tgtLang in this.tgtLanguage) {
          targetLangs.push(this.tgtLanguage[tgtLang]['value'])
        }

        let data = {
          specialization: this.specialization,
          service_type: this.serviceType,
          source_language: this.srcLanguage,
          target_language: targetLangs,
          quantity_type: this.qtyType,
          email: this.email,
          phone: this.phone,
          forditas_teljesitesenek_modja: this.forditasTeljesitesenekModja,
          quantity: this.quantity
        }
        //határidő hozzáadása
        if(this.hatarido != '' && this.hatarido) {
          data["hatarido"] = this.formatDate(this.hatarido)
        } else if(this.javasoltHataridoDate && this.javasoltHataridoDate != '-') {
          data["hatarido"] = this.javasoltHataridoDate
        }
        //megjegyzés hozzáadása
        if(this.note != '') {
          data["note"] = this.note
        }
        //dokumentum típusa hozzáadása
        if(this.documentType != '') {
          data["document_type"] = this.documentType
        }
        return data
      }
      return false;
    }
  },
  methods: {
    async getFormDatas() {
      const formDatas = await this.$http.get(this.apiUrl+'getData')
      this.formDatas = formDatas.data
    },
    // Megrendelés gombra kattintás esemény követése
    trackOrder() {
        this.$gtag.event('Megrendeles', {
          'event_category': 'BUTTON'
        })
    },

    // Árajánlat gombra kattintás esemény követése
    trackOffer() {
        this.$gtag.event('ArajanlatMailben', {
          'event_category': 'BUTTON'
        })
    },

    crateLangItemPrices(value, label, unitPrice) {
      let price = Math.round(unitPrice * this.quantity)
      return {
        price: this.formatNumber(price),
        langValue: value,
        langLabel: label,
        unitPrice: this.formatNumber((unitPrice).toFixed(1)),
        discountPrice: this.formatNumber((price*this.volumeDiscount).toFixed(1))
      }
    },
    getFelarSzorzo(name) {
      if(name == 'surgos' || name == 'extra_surgos') {
        return this.formDatas['global_prices']['surcharges']['values'][name]['value']
      }
      return null
    },
    formatDeadline(date) {
      let
        year = date.getFullYear(),
        month  = date.getMonth()+1,
        day = date.getDate(),
        days = this.getDayDiff(date, new Date())
      return `${year}.${month}.${day} (${days} nap)`
    },
    getProductData() {
      //szükséges egy elem #product-data, ahol data-product_id be van állítva
      let elem = document.getElementById('product-data')
      this.productId = Number.parseInt(elem.dataset.product_id)
      this.checkoutPageUrl = window.atob(elem.dataset.checkout_page)
      this.documentsSample = JSON.parse(elem.dataset.documents_sample)
    },
    //kosár küldése a woocommerce kosárba
    sendToWpCart() {
      //todo set file count
      this.waitingReponse()

      let
        formData = new FormData(),
        data = this.validProductData
      //get files
      this.files.forEach((file, index) => {
        formData.append(`source_document_${index}`, file)
      })
      formData.append('documentinfo',window.btoa(JSON.stringify(this.documentInfo)));
      //set other productData
      for(const property in data) {
        formData.append(`${property}`, data[property])
      }
      formData.append(`variation_id`, 0)
      formData.append(`add-to-cart`, this.productId)
      if(this.charRepeats.length > 0) {
        this.charRepeats.forEach((charRepeat, index) => {
          formData.append(`charRepeats[${index}]`, charRepeat)
        })
      }
      if(this.chars.length > 0) {
        this.chars.forEach((charNum, index) => {
          formData.append(`chars[${index}]`, charNum)
        })
      }
      //send to wp
      //actual url
      let actual_url = window.location.href
      this.$http.post(
        `${actual_url}`,
        formData,
        {
          headers: {'Content-Type': 'multipart/form-data'}
        }
      ).then( (response) => {
        if(response.data) {
          this.wpApiResponse = response.data
        }
        //redirect checkout page
        window.location.href = this.checkoutPageUrl
        this.stopWaitingResponse()

      })
      .catch( (error) => {
        console.log(error)
        this.wpApiResponse = []
        this.showPopup('failed')
        this.stopWaitingResponse()
      });
    },
    /**
     * Ajánlat hozzáadása
     */
    addToOffer() {
      this.waitingReponse()
      let
        formData = new FormData(),
        data = this.validProductData
      data['method'] = 'addToOffer'
      data[`charRepeats`] = this.charRepeats
      data['documentinfo'] = window.btoa(JSON.stringify(this.documentInfo))
      this.files.forEach(file => formData.append(`files[]`, file))
      formData.append(
        'data',
        JSON.stringify(data)
      )
      this.$http.post(
        `${this.apiUrl}${data['method']}`,
        formData,
        {
          headers: {'Content-Type': 'multipart/form-data'}
        }
      ).then( (response) => {
        if(response.data) {
          this.wpApiResponse = response.data
          this.showPopup('success_add_to_offer')
        }
        this.stopWaitingResponse()
      })
      .catch( (error) => {
        console.log(error)
        this.wpApiResponse = []
        this.showPopup('failed')
        this.stopWaitingResponse()
      });
    },
    showPopup(type) {
      this.popupMessageShow = true
      this.wpApiResponseType = type
    },
    testPrice() {
      let
        formData = new FormData(),
        data = this.validProductData
      data['method'] = 'testPrice'
      this.files.forEach(file => formData.append(`files[]`, file))
      formData.append(
        'data',
        JSON.stringify(data)
      )
      this.$http.post(
        `${this.apiUrl}addToCart`,
        formData,
        {
          headers: {'Content-Type': 'multipart/form-data'}
        }
      ).then( (response) => {
        if(response.data) {
          this.wpApiResponse = response.data
        }
        this.showPopup('success')
        this.stopWaitingResponse()
      })
      .catch( function(error) {
        console.log(error)
        this.wpApiResponse = []
        this.showPopup('failed')
        this.stopWaitingResponse()
      });
    },
    getNormalCapacityDate() {
      let date = new Date()
      date.setDate(date.getDate() + this.normalCapacityDays)
      return date
    },
    formatDate(date) {
      let
        day = date.getDate(),
        month = date.getMonth() + 1,
        year = date.getFullYear()
      if(month < 10) {
        month = '0' + month
      }
      if(day < 10) {
        day = '0' + day
      }
      return year + '-' + month + '-' + day
    },
    //határidő kategória kezdő dátuma
    getStartCapacityDate(capacityType) {
      let capTypes = [
        'surgos',
        'extra_surgos'
      ]
      if(this.qtyType != '' && capTypes.includes(capacityType)){
        let capacity = this.getCapacity(capacityType)
        if(capacity['max']) {
          let days = Math.ceil(
            (
              this.quantity * this.serviceTypeMult / capacity['max']
            )
            * this.targetLangDeadlineMultiplier + this.getDefaultDeadlineMultiplier()
          )
          let date = new Date()
          date.setDate(date.getDate() + days)
          return date
        }
      }
      return null
    },
    waitingReponse() {
      if(!this.waitResponse) {
        this.waitResponse = true
      }
    },
    stopWaitingResponse() {
      if(this.waitResponse) {
        this.waitResponse = false
      }
    },
    getDefaultDeadlineMultiplier() {
      return this.formDatas['quantity_type']['datalist']['options']['deadline']['capacity']['normal']['value'];
    },

    //napi kapacitás lekérdezése az adott mennyiségi típusra
    getCapacity(capacityType) {
      let capTypes = [
        'normal',
        'surgos',
        'extra_surgos'
      ]
      if(this.qtyType != '' && capTypes.includes(capacityType)){
        //intevalummal rendelkező kapacitástípusok (sürg, extra sürg...)
        if(typeof this.formDatas['quantity_type']['datalist']['options'][this.qtyType]['capacity'][capacityType]['values'] != 'undefined') {
          return this.formDatas['quantity_type']['datalist']['options'][this.qtyType]['capacity'][capacityType]['values']
        }
        //csak min kapacitással rendelkező értékek (normál)
        else if(typeof this.formDatas['quantity_type']['datalist']['options'][this.qtyType]['capacity'][capacityType]['value'] != 'undefined') {
          return this.formDatas['quantity_type']['datalist']['options'][this.qtyType]['capacity'][capacityType]['value']
        }
      }
      return null
    },
    getLanguagePrices(langKey) {
      if(this.qtyType && this.qtyType != '') {
        switch(this.qtyType) {
          case 'karakterszam':
            return this.formDatas['source_language']['datalist']['options'][langKey]['price']
          case 'oldalszam':
            return this.formDatas['source_language']['datalist']['options'][langKey]['price']['extra']['oldalszam']
          case 'darabszam':
            return this.formDatas['source_language']['datalist']['options'][langKey]['price']['extra']['darabszam']
        }
      }
      return null
    },
    /**
     * Formázott mennyiség készítése az árhozpl: 1000 -> 1.000
     * @param  {[type]} num [description]
     * @return string
     */
    formatNumber(num) {
      let numStr = num.toString()
      numStr = numStr.replace('.',',')
      return numStr.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
    },
    formatHuf(num) {
      num = Math.round(num)
      return this.formatNumber(num) + ' FT'
    },
    formatPrice(num) {
      if(num<this.minPrice) {
        num = this.minPrice
      }
      num = Math.round(num)
      return this.formatNumber(num) + ' FT'
    },
    /**
     * dátumok közötti különbség kiszámolása napokban
     * @param  {Date} date1 [description]
     * @param  {Date} date2 [description]
     * @return {int}       [description]
     */
    getDayDiff(date1,  date2) {
      return Math.floor((Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate()) - Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate()) ) /(1000 * 60 * 60 * 24))
    },
    //mennyiségi típus lekérdezése a dokumentumtípushoz
    getDocumentQtyType(specialization) {
      for(const property in this.formDatas['specialization']['datalist']['options']) {
        if(property == specialization) {
          if(typeof this.formDatas['specialization']['datalist']['options'][property]['quantityType'] != 'undefined') {
            return this.formDatas['specialization']['datalist']['options'][property]['quantityType']
          } else {
            return 'karakterszam'
          }
        }

        //search deeper
        if(typeof this.formDatas['specialization']['datalist']['options'][property]['options'] != 'undefined') {
          for(const subProp in this.formDatas['specialization']['datalist']['options'][property]['options']) {
            if(subProp == specialization) {
              if(typeof this.formDatas['specialization']['datalist']['options'][property]['options'][subProp]['quantity_type'] != 'undefined') {
                return this.formDatas['specialization']['datalist']['options'][property]['options'][subProp]['quantity_type']
              } else {
                return 'karakterszam'
              }
            }
          }
        }
      }
      return 'karakterszam'
    },
    
    // A felhasználó "A folytatáshoz töltse ki a mezőket és erősítse meg adatait!" üzenetre kattintva is megerősítheti az adatait
    triggerSendAdatok(){

      // hack: le kell kérdezni közvetlenül az Adatok komponenstől a referenciát, mivel mi a parent elemben vagyunk
      // A "sendAdatokBtn" referencia egy duplikált "Adatok megerősítése" gombra mutat, amit hozzáadunk a DOM-hoz, de elrejtünk.
      // Az eredeti gomb nem volt jó, mert az egy if-else strukturális direktívában volt, így abban az esetben, amíg
      // a felhasználó nem töltötte ki az e-mail mezőt helyesen, nem adódott volna hozzá a DOM-hoz, így a rá vonatkozó referencia
      // undefined lett volna
      // Továbbá: egy kicsit változtatni kellett a meghívott sendAdatok() metóduson, hogy ne állítsa az input-okat disabled-re, különben a felhasználó
      // nem tudná megadni az adatait. Ez azért kellett, mert "A folytatáshoz töltse ki a mezőket és erősítse meg adatait!" elemre a felhasználó
      // hamarabb is rákattinthat, még mielőtt megadná az adatait. A meghívott metódus nem állítja true-ra a "waitMegerosites" tulajdonságot,
      // mert az disabled-re állítja az inputokat
      const elem = this.$children[2].$refs.sendAdatokBtn;
      elem.click();

      // az eredeti gomb sendAdatok() metódusát is meghívjuk, amennyiben az már része a DOM-nak
      // ez azért kell, mert csak ebben az esetben enged tovább az űrlap (a firstPartPassed() metódusnál a
      // "megerosites"-nek igaznak kell lenni
      const btn = this.$children[2].$refs.sendAdatokBtnContinue
      if (btn) {
        btn.click();
      }
    }
  }
}
</script>

<style >
  @import '../assets/css/ForditasForm.css';
</style>
<style lang="scss">
@import '../assets/sass/_variables.scss';
/* boostrap felülírás */
.forditas-wrapper{
  margin-left: 15px;
  .form-control{
    box-shadow: none !important;
    border: none;
  }
  textarea#comment{
    border: 1px solid #dddddd;
  }
  button:disabled,button[disabled]{
    opacity: .65;
    background: #999;
    cursor: not-allowed;
  }
  .mx-datepicker .mx-input-wrapper input.mx-input{
    height: 38px;
    line-height: 38px;
  }
  section.form-box,.forditas-urlap-summary, #forditas-rendeles-urlap-add-to-cart {
    .container{
      width: 100%;
    }
  }
  #forditas-rendeles-urlap-add-to-cart{
      margin-bottom: 1em;
  }
  .forditas-urlap-summary{
    margin-right: 1em;
  }
  #forditas-rendeles-urlap-add-to-cart {
    .ico-left{
      margin-left: 55px;
    }
    .ico{
      width: 40px;
      float: left;
    }
  }
  .radio label>span.color-primary{
    display: block;
    margin-bottom: 1em;
  }
  .color-secondary{
    color: $secondary-color;
  }
  .font-big{
    font-weight: bold;
    text-transform: uppercase;
  }
  h4.font-big{
    color: #3e3e3e;
  }
  .appeal{
    margin: .5em 0;
  }
  label[for="comment"] {
    font-weight: normal;
  }
  .form-box .radio-selection.row .form-box-item:not(:first-child){
    border-left: 1px solid #dedede;
  }
  .form-box .row.radio-selection {
    border: 1px solid #dedede;
    border-radius: 8px;
    overflow: hidden;
  }
  .urlap-title{
    padding-bottom: .7em;
  }
  #forditas-rendeles-urlap-add-to-cart {
    h4.font-big{
      margin-bottom: 1em;
    }
    .box .row .col-sm-6{
      padding-bottom: 1em;
    }
    .finish-circle.finished + .container{
        h2{
          color: #3ab94e;
        }
    }
  }
  #forditas-rendeles-urlap section.form-box.incompleted::before,.finish-circle:not(.finished){
    background: #fba052;
  }
  .form-box-item.invalid{
    border-left: solid #fcc7ad 5px;
  }
}
.box .alert{
  margin-bottom: 0;
}
.color-danger{
  color: #e55;
}
.mb-1e{
  margin-bottom: 1em;
}
</style>
